/**
 * Represents ChipList `Chip` model class.
 */
var Chip = /** @class */ (function () {
    function Chip() {
    }
    return Chip;
}());
export { Chip };



//////////////////
// WEBPACK FOOTER
// /Users/erikoberhausen/Documents/upperhouse/sukle/awkwardagent/awkward/web/app/themes/sage/node_modules/@syncfusion/ej2-buttons/src/chips/chip.js
// module id = 121
// module chunks = 0 1 2 3 4 5